import React from 'react';
import OpenInNewWindow from '../../icons/open-new-window';

/**
 * @param {string} linkText
 * @param {string} linkSummary
 * @param {string} linkHref 
 */
const DropdownListLink = ({ linkText, linkSummary, linkHref }) => (
    <li className="dropdown-list-item">
        <a className="dropdown-link" href={linkHref} rel="noopener noreferrer" target="_blank">
            <div className="dropdown-content">
                <span>{linkText}</span>
                <p>{linkSummary}</p>
            </div>
            <OpenInNewWindow />
        </a>
    </li>
);

export default DropdownListLink;
